import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GlobalService } from '../../core/services/global.service';

@Injectable()
export class RegionInterceptor implements HttpInterceptor {
  private readonly EU_REGION = 'eu-west-1';

  constructor(private globalService: GlobalService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // update url based on user's region
    const region = this.globalService.getRegion();
    if (region === this.EU_REGION) {
      req = req.clone({
        url: req.url.replace(environment.apiUrl, environment.euApiUrl),
      });
    }
    return next.handle(req);
  }
}
